import { render, staticRenderFns } from "./SecuritySettings.vue?vue&type=template&id=4042649c&scoped=true"
import script from "./SecuritySettings.vue?vue&type=script&lang=js"
export * from "./SecuritySettings.vue?vue&type=script&lang=js"
import style0 from "./SecuritySettings.vue?vue&type=style&index=0&id=4042649c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4042649c",
  null
  
)

export default component.exports